import { render } from "./LoadingSpinner.vue?vue&type=template&id=0f9016c2&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=0f9016c2&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9016c2"]])

export default __exports__